import { render, staticRenderFns } from "./mock-receipt-card.vue?vue&type=template&id=a54e2d16&scoped=true&"
import script from "./mock-receipt-card.vue?vue&type=script&lang=js&"
export * from "./mock-receipt-card.vue?vue&type=script&lang=js&"
import style0 from "./mock-receipt-card.vue?vue&type=style&index=0&id=a54e2d16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54e2d16",
  null
  
)

export default component.exports